var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { createElement, Component } from 'react';
import { findDOMNode } from 'react-dom';
import { extendObservable, action, runInAction } from 'mobx';
import { observer } from 'mobx-react';
var classNames = {
  transitioning: 'transitioning',
  enter: 'enter',
  enterActive: 'enter-active',
  exit: 'exit',
  exitActive: 'exit-active'
};

var TransitionGroup = function (_Component) {
  _inherits(TransitionGroup, _Component);

  function TransitionGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TransitionGroup.__proto__ || Object.getPrototypeOf(TransitionGroup)).call.apply(_ref, [this].concat(args))), _this), _this.innerRefs = {}, _this.start = action(function () {
      var _this$props = _this.props,
          to = _this$props.to,
          from = _this$props.from;
      var routes = [to, from];
      var afterCallbacks = [];
      Object.keys(_this.innerRefs).forEach(function (key) {
        var el = findDOMNode(_this.innerRefs[key]);
        var route = routes.find(function (route) {
          return route && route.key === key;
        });

        if (route) {
          runInAction(function () {
            route.data.transitionState = route === to ? 'entering' : 'exiting';
          });

          if (el instanceof window.HTMLElement) {
            // Find element with data-transition-ref attribute to add transitionend event listener
            var target = el.querySelector('[data-transition-ref]');
            var inner = el.firstChild;

            if (target) {
              var handleTransitionEnd = function handleTransitionEnd(ev) {
                runInAction(function () {
                  route.data.transitionState = route === to ? 'entered' : 'exited';
                });
                target.removeEventListener('transitionend', handleTransitionEnd);
              };

              target.addEventListener('transitionend', handleTransitionEnd, false);
            }

            afterCallbacks.push(function () {
              // Force repaint
              inner.scrollTop; // Add ephemeral classname to trigger animation

              inner.classList.add(route === to ? classNames.enterActive : classNames.exitActive);
            });
          }
        }
      });
      afterCallbacks.forEach(function (cb) {
        return cb();
      });
    }), _this.stop = action(function () {
      var to = _this.props.to;

      if (to) {
        to.data.transitionState = 'entered';
      } // Clear out refs


      _this.innerRefs = {};
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TransitionGroup, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var isTransitioning = this.props.isTransitioning;

      if (isTransitioning) {
        this.start();
      } else {
        this.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          from = _props.from,
          to = _props.to,
          isTransitioning = _props.isTransitioning,
          additionalProps = _props.additionalProps;
      var routes = [];

      if (from) {
        routes.push({
          route: from,
          key: getKey(from),
          className: isTransitioning ? classNames.transitioning + ' ' + classNames.exit : ''
        });
      }

      if (to) {
        routes.push({
          route: to,
          key: getKey(to),
          className: isTransitioning ? classNames.transitioning + ' ' + classNames.enter : ''
        });
      }

      return React.createElement('div', {
        className: 'router-transition-group'
      }, routes.map(function (_ref2) {
        var route = _ref2.route,
            key = _ref2.key,
            className = _ref2.className;
        return React.createElement(TransitionItem, {
          key: key,
          route: route,
          className: className,
          additionalProps: additionalProps,
          innerRef: function innerRef(ref) {
            return _this2.innerRefs[route.key] = ref;
          }
        });
      }));
    }
  }]);

  return TransitionGroup;
}(Component); // Need to wrap the item so we can properly set the innerRef


var TransitionItem = function (_Component2) {
  _inherits(TransitionItem, _Component2);

  function TransitionItem() {
    _classCallCheck(this, TransitionItem);

    return _possibleConstructorReturn(this, (TransitionItem.__proto__ || Object.getPrototypeOf(TransitionItem)).apply(this, arguments));
  }

  _createClass(TransitionItem, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          route = _props2.route,
          className = _props2.className,
          additionalProps = _props2.additionalProps,
          innerRef = _props2.innerRef;
      return React.createElement('div', {
        className: 'router-transition-item',
        'data-route-key': route.key,
        ref: innerRef
      }, createElement(route.data.component, _extends({
        route: route,
        className: className
      }, additionalProps)));
    }
  }]);

  return TransitionItem;
}(Component);

var getKey = function getKey(route) {
  if (typeof route.node.value.onTransition === 'function') {
    return route.key;
  } else {
    return componentId(route.data.component);
  }
};

var componentId = function () {
  var idx = 0;
  return function (component) {
    return component.$$componentId || (component.$$componentId = 'component:' + ++idx);
  };
}();

export default observer(TransitionGroup);